<template>
 <div class="before-horizontal">
     <div class="box_title_chapo_mecanique">
      <h2 class="title-box">
        La mécanique de la fraude
      </h2>
      <h5 class="chapo" id="chapoMecanique">
        Pour amener des épargnants, y compris les plus prudents, à miser gros sur des produits exotiques (cryptomonnaies, vin, cheptels etc.), les escrocs ont adopté au fil des ans une méthode bien huilée : attirer le chaland en lui promettant monts et merveilles, rendre crédible leur offre, mettre le futur client sous pression pour lui faire croire que c’est « maintenant ou jamais », pour enfin, lui faire verser des milliers d’euros à l’étranger.</h5>


     </div>

     <SlideShowAndText />
     <Observer
             @intersect="progressBar2(42)"
     />

     <div class="bidon_container">
         <h3>Comment rendre 100 % crédible une offre 100 % bidon ?</h3>
         <div class="bidon_subcontainer">
             <div class="bidon_text">
                 <h4>L'internaute atterrit sur un faux site de placements financiers</h4>
                 <p>Même s'ils vendent des produits apparemment différents, toutes ces vitrines utilisent les mêmes astuces pour inspirer confiance.</p>
             </div>
             <img src="/img/daxbase.jpg" alt="image site">

         </div>
     </div>


     <Observer
             @intersect="progressBar2(44)"
     />
     <div class="bloc_fausses_references">
         <h4>Pour apparaître comme le plus sérieux possible, le site présente toujours de fausses références :</h4>
         <div class="bloc_picto_card">
             <div class="picto_card">
                 <img src="img/icon/adresse.svg" alt="picto adresse">
                 <p>Une adresse prestigieuse en France (Champs-Elysées, la Défense etc.)</p>
             </div>

             <div class="picto_card">
                 <img src="img/icon/partenariats.svg" alt="picto partenariat">
                 <p>Des partenariats de renoms avec de très grandes entreprises françaises</p>
             </div>
             <div class="picto_card">
                 <img src="img/icon/histoire.svg" alt="picto histoire">
                 <p>Une longue expérience avec une prétendue date de création au XIXe siècle</p>
             </div>
        </div>

         <Observer
                 @intersect="progressBar2(46)"
         />
         <!--  <button @click="showMap" class="bouton_realite">
               <p class="bouton_realite_text">Voir la réalité ?</p>
               <img src="img/icon/fleche_bas.svg" alt="fleche bas" class="fleche_bas">
           </button>-->
           <div class="container_world_map">

          <!-- <div v-if="show_map" class="container_world_map">-->
             <h4 class="world_map_title">En réalité, ces sites sont basés à l'étranger et récemment mis en ligne</h4>
              <div class="world_map_subcontainer">
                  <img src="img/cartes_et_graphs/carte_sites.svg" alt="carte du monde">
                  <div class="days">
                      <div class="days_first_line">
                          <p class="picto_duree_text_nombre picto_duree_texts">138</p>
                          <img src="img/icon/picto_durée.svg" alt="nombre de jours où les sites sont restés en ligne" class="picto_duree" />
                      </div>
                      <div class="days_second_line">
                          <p class="picto_duree_text_jours picto_duree_texts">jours</p>
                          <img src="img/icon/picto_durée.svg" alt="nombre de jours où les sites sont restés en ligne" class="picto_duree_mobile" />
                      </div>
                      <p class="picto_duree_text_chapo">La moitié des sites Internet sont repérés par l'autorité des marchés financiers (AMF) avant d'atteindre cet âge (4 mois et demi).</p>
                      <p class="picto_duree_text_explication">Calculs réalisés à partir des sites internets détectés en 2019 par l'AMF. La date de mise en ligne de ces sites a été obtenue - lorsqu'elle était disponible - auprès d'un service de "whois". Attention, l'échantillon présente de grandes disparités, certains sites ont été repérés par les autorités une semaine après leur creation.</p>
                  </div>
              </div>

         </div>
         <Observer
                 @intersect="progressBar2(52)"
         />
    </div>



         <Bubble />


     <Observer
             @intersect="progressBar2(58)"
     />

         <div class="tirelire">
             <h4>Comment convaincre un économe de casser sa tirelire ?</h4>
             <h5>Une fois l'épargnant ferré sur Internet, encore faut-il trouver un moyen d'entrer en contact direct avec lui, nouer un dialogue pour provoquer &laquo; l'acte d'achat &raquo;.</h5>
            <div class="gif_bloc">
                 <img src="img/icon/gif_arnaque.gif" alt="un gif d'un monsieur devant son ordinateur">
                 <p>Les escrocs réclament systématiquement à leurs futurs clients un e-mail et un numéro de téléphone pour, officiellement, vous &laquo; ouvrir un espace personnel sur le site &raquo;. Objectif réel : vous référencer dans leurs bases de données et vous démarcher par téléphone.</p>
             </div>


         </div>
     <Observer
             @intersect="progressBar2(60)"
     />

        <div class="postercontainer">
            <h4>Comment réussir à vous faire virer des milliers d'euros à l'étranger ?</h4>
            <div class="infoposter_desk_haut">
            </div>
            <button @click="showPoster" class="bouton_bonus">
                        <p class="bouton_bonus_text">BONUS :</p>
                        <p class="bouton_bonus_text">L'arnaque honteuse</p>
                        <img src="img/icon/fleche_bas.svg" alt="fleche bas" class="fleche_bas">
            </button>
             <div v-if="show_poster" class="infoposter_desk_bas">
             </div>
         </div>
     </div>

</template>

<script>
import Bubble from "@/components/chartsHandler/Bubble.vue";
import SlideShowAndText from "../components/imagesHandler/SlideshowAndText";
import Observer from "@/components/Observer.vue";


export default {
  name: "Mecanique",
  components:{
    Bubble,
    SlideShowAndText,
    Observer,

  },
    data(){
      return{
          show_map:false,
          show_poster:false
      }
    },
    methods:{
        showMap(){
            this.show_map = !this.show_map
        },
        showPoster(){
            this.show_poster = !this.show_poster
        },
        progressBar2(percentage){
            var myprogress = document.getElementById("progressbar")
            myprogress.setAttribute("value", percentage)

        }
    }
  
};
</script>

<style>

.box_title_chapo_mecanique {
        display:flex;
        flex-direction:column;
        align-items:center;
        justify-content:center;
        position:relative;
        width:100vw;
        height:50vh;
        top:5vh;
        margin-bottom:10vh;
        margin-top:10vh;
            }

@media screen and (max-width: 399px) {
    .box_title_chapo_mecanique{
        justify-content: space-around;
        height: 60vh;
        width: 100vw;
        margin-top:30vh;
        margin-bottom: 10vh;

    }

}


@media screen and (max-width: 430px) and (min-width: 400px){
    .box_title_chapo_mecanique{
        justify-content: space-around;
        top: 0;
        height: 50vh;
        width: 100vw;
        margin-top:10vh;
        margin-bottom: 0vh;
    }
}


@media screen and (max-width: 1000px) and (min-width: 431px){
    .box_title_chapo_mecanique{
        justify-content: space-around;
        top: 0;
        height: 40vh;
        width: 100vw;
        margin-top:10vh;
        margin-bottom: 10vh;
    }
}




/*--------------- bidon----------------*/

.bidon_container{
    position:relative;
    display:flex;
    flex-direction: column;
    height: 50vh;
    width:100vw;
    align-items: center;
    justify-content:space-evenly;
    margin-bottom:15vh;
   }





.bidon_subcontainer{
    display:flex;
    flex-direction: row;
    height: 50%;
    width:70%;
    justify-content: space-around;
    margin:0;
}

.bidon_subcontainer img{
    margin:0;
    width:40vw;
    height:37vh;
}
.bidon_text{
    display:flex;
    flex-wrap: wrap;
    justify-content:flex-end;
    align-items:flex-end;
    height:37vh;
    width:23%;
    margin:0;
}

.bidon_text h4{
    margin-top:0;
}




/*---------------- bidon responsive--------*/

@media screen and (max-width:430px) {
    .bidon_container{
        position:relative;
        display:flex;
        flex-direction:column;
        height:70vh;
        width:100vw;
        justify-content:center;
        margin-top:10vh;
        margin-bottom:0;

           }


    .bidon_subcontainer{
        position:relative;
        display:flex;
        flex-direction:column-reverse;
        height:50vh;
        width:100vw;
        justify-content:center;
        align-items: center;
        margin:0;
    }

    .bidon_subcontainer img{
        position:relative;
        margin:0;
        width:100vw;
        height:auto;
    }

    .bidon_text{
        position:relative;
        display:flex;
        flex-direction: column;
        justify-content:center;
        align-items:flex-start;
        height:40vh;
        width:70%;
        margin:0;
    }

    .bidon_container h3{
        width:77%
    }


}

@media screen and (max-width:1000px) and (min-width:431px) {
    .bidon_container{
        position:relative;
        display:flex;
        flex-direction:column;
        height: 70vh;
        width:100vw;
        justify-content:center;
        margin-bottom:0;
        margin-top:5vh;

    }


    .bidon_subcontainer{
        position:relative;
        display:flex;
        flex-direction:column-reverse;
        height:75%;
        width:100vw;
        justify-content:center;
        align-items: center;
        margin:0;
    }

    .bidon_subcontainer img{
        position:relative;
        margin:0;
        width:100vw;
        height:auto;
    }

    .bidon_text{
        position:relative;
        display:flex;
        flex-direction: column;
        justify-content:center;
        align-items:center;
        height:37vh;
        width:80%;
        margin:0;
    }

    .bidon_container h3{
        width:77%
    }


}





/*------------ FIN BIDON --------------*/

.bloc_picto_card{
    display:flex;
    width:80vw;
    height:100%;
    justify-content:center;
    }
.picto_card{
    padding:2%;
    width:20vw;
    height:55vh;
    text-align:center;
}


div.picto_card img {
        width: 87%;
        height: 65%;
    }

div.picto_card p{
    margin-top:10%;
    width:100%;
}


@media screen and (max-width:1000px) and (min-width:431px){

    .bloc_picto_card{
         width:100vw;
        display: flex;
       justify-content:space-around;
        height:30vh;
    }

    .picto_card{
        padding:0px;
        width:29vw;
        height:30vh;
    }
    div.picto_card img {
        width: 100%;
        height: 40%;
    }

    div.picto_card p{
        margin:0px;
        width:100%;
        display:flex;
        justify-content: center;

    }
}

@media screen and (max-width:430px){
    .bloc_picto_card{
        width:100vw;
        display: flex;
        justify-content:space-around;
    }

    .picto_card{
        padding:0px;
        width:29vw;
        height:40vh;
    }
    div.picto_card img {
        width: 100%;
        height: 40%;
    }

    div.picto_card p{
        margin:0px;
        width:100%;
        display:flex;
        justify-content: center;

    }

}




/*---- bloc faire le plus sérieux possible ---*/
.bloc_fausses_references{
    top:5vh;
    position:relative;
    display: flex;
    flex-direction:column;
    align-items:center;
    justify-content: center;
    height:100%;
  }

div.bloc_fausses_references h4{
    width:65%;
    text-align:center;
}


/* bouton realite*/

.bouton_realite{
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content:space-around;
    background-color: #2D3562;
    width:215px;
    height:84px;
    color:white;
    border-radius:15px;
    padding:10px;
}


button.bouton_realite img{
    height:12.35px;
    width:20.5px;

}
.bouton_realite_text {
    margin: 0;
    font-family: 'Open Sans', helvetica, serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: 0px;
    text-align: center;

}


    @media screen and (max-width:1000px){

    .bouton_realite{
        font-family: 'Open Sans', Helvetica, serif;
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
        letter-spacing: 0px;
        text-align: center;
        width:149px;
        height:71px;
    }

    .bouton_realite_text {
        margin:0;
        font-family: 'Open Sans', Helvetica, serif;
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
        letter-spacing: 0px;
        text-align: center;

    }



}


/*------ FIN BLOC SERIEUX POSSIBLE------*/






/*---------- section map ----------*/

.container_world_map {
    position:relative;
    height: auto;
    width:100%;
    top:10vh;
    display: flex;
    flex-direction:column;
    justify-content:center;
    align-items: center;
    }

.world_map_title{
    text-align: center;
    margin-bottom:0;

}

.world_map_subcontainer{
    position:relative;
    display:flex;
    width:100%;
    height:auto;
    /*left:2%*/
    margin:0;
    }


div.world_map_subcontainer img{
 position:relative;
 width:90%;
 height:auto;
 left:1%;
 margin:0;
 transform: translateY(-1%) translateX(4%) ;
}


.days{
    position:relative;
    display:flex;
    flex-direction:column;
    width:20%;
    height:auto;
    right:6%;
    justify-content:center;
        }
.days_first_line{
    position:relative;
    width:60%;
    display:flex;
    justify-content:space-between;
    align-items: flex-end;
}

.picto_duree_texts{
    font-family: 'Open Sans', Helevetica, serif;
    font-style: normal;
    font-weight: bold;
    font-size: 48px;
    line-height: 65px;
    color: #2D3562;
}

.picto_duree_text_nombre{
    position: relative;
    margin:0;
    bottom:10%;

}

.picto_duree{
    position:relative;
    max-width:40%;
    height: auto;
    margin:0;
    padding:0;
    }

.picto_duree_text_jours{
    position:relative;
    margin:0;
    }

.picto_duree_text_chapo{

}

.picto_duree_text_explication{
    position: relative;
    width: 100%;
    height:auto;
    /*left:-40%;*/


    font-family: 'Open Sans', Helevetica, serif;
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 18px;
    text-align: justify;

    color: #2D3562;
}

.picto_duree_mobile{
    display:none;
}


@media screen and (max-width:430px){
    .world_map_subcontainer{
        position:relative;
        display:flex;
        flex-direction:column;
        align-items: center;
        justify-content:center;
        width:100%;
        height:auto;
        /*left:2%*/
        margin:0;
    }

    div.world_map_subcontainer img{
        left:0%;
        margin:0;
        width:90%;
        transform: translateY(0%) translateX(6%) ;
    }

    .days{
            position: relative;
            display: flex;
            flex-direction: column;
            width:60%;
            height: auto;
            right:0px;
            align-items: flex-start;
    }




    .days_first_line{
        position:relative;
        width:100%;
        display:flex;
        justify-content:space-between;
        align-items: flex-start;
    }

    .picto_duree{
        display:none;

    }
    .days_second_line{
        display:flex;
        width:90%;
    }
    .picto_duree_mobile{
        display:flex;
        justify-content: center;
        position:relative;
        max-width:30%;
        height: auto;
        margin:0;
        padding:0;
    }
    .picto_duree_text_jours{
        position:relative;
        margin:0;
        width:70%;
        height:100%;
        text-align: left;
    }



}
/* responsive i pad*/

@media screen and (max-width:1000px) and (min-width:431px){
    .world_map_subcontainer{
        position:relative;
        display:flex;
        flex-direction:column;
        align-items: center;
        justify-content:center;
        width:100%;
        height:auto;
        margin:0;
    }

    div.world_map_subcontainer img{
        left:0%;
        margin:0;
        width:90%;
        transform: translateY(0%) translateX(6%) ;
    }

    .days{
        position: relative;
        display: flex;
        flex-direction: column;
        width:50vw;
        height:auto;
        right:0px;
        align-items: center;
    }


    div.days p{
        margin-top: 1%;
        margin-bottom:3%;
    }

    .days_first_line{
        position:relative;
        width:25vw;
        display:flex;
        justify-content:space-between;
        align-items: flex-start;
    }

    .picto_duree{
        display:none;

    }
    .days_second_line{
        display:flex;
        width:25vw;
    }
    .picto_duree_mobile{
        display:flex;
        justify-content: center;
        position:relative;
        max-width:30%;
        height: auto;
        margin:0;
        padding:0;
    }
    .picto_duree_text_jours{
        position:relative;
        margin:0;
        width:70%;
        height:100%;
        text-align: left;
    }



}






/*---------- section gif ----------*/
.tirelire{
    position:relative;
    top:15vh;
    width:100vw;
    height:85vh;
    display:flex;
    flex-direction:column;
    align-items: center;
}

div.tirelire h5{
    width:50vw;
    text-align: center;

}


@media screen and (max-width:430px){
    .tirelire{
        position:relative;
        margin-top:15vh;
        top:0px;
        width:100vw;
        height:65vh;
        display:flex;
        flex-direction:column;
        align-items: center;
    }

    div.tirelire h5{
        width:70vw;
        text-align: center;

    }

}

@media screen and (max-width:1000px) and (min-width:431px) {
    .tirelire {
        position: relative;
        margin-top: 5vh;
        top: 0px;
        width: 100vw;
        height: 60vh;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    div.tirelire h5 {
        width: 70vw;
        text-align: center;

    }

}


.gif_bloc{
    display:flex;
    justify-content:space-between;

}
div.gif_bloc img{
    height:303px;
    width:548px;
}
div.gif_bloc p{
    width:20.72vw;
    padding-top:2vh;
    padding-left: 2vw;
}


@media screen and (max-width: 1000px){
    .gif_bloc{
        display:flex;
        flex-direction: column;
        align-items:center;
        justify-content: space-between;
    }

    div.gif_bloc img{
        height:38vw;
        width:70vw;
    }

    div.gif_bloc p{
        width:70vw;
        padding-top:0px;
        padding-left: 0px;
    }
}


/*---------- FIN GIF -----------*/



/*---------- INFO POSTER-------------*/
.postercontainer{
    height:100%;
    width:100vw;
    display:flex;
    flex-direction:column;
    align-items:center;
}

div.postercontainer h3{
    width:50vw;
    text-align: center;
}

.infoposter_desk_haut{
    height:2258px;
    width:100vw;
    background-image: url("/img/poster/desktop/haut.svg");
    background-repeat: no-repeat;
    background-position:center;
}


.bouton_bonus {
    position:relative;
    top:-4vh;
    transform: translateX(5%);


    background-color:#13345c;
    color: #fff;
    width: 215px;
    height:84.86px;
    text-align:center;
    border-radius:15px;
    z-index:2;


    font-family: 'Open Sans', Helvetica, serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: 0px;


}


.bouton_bonus_text {
    margin: 0;
    font-family: 'Open Sans', helvetica, serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: 0px;
    text-align: center;

}

button.bouton_bonus img{
    height:12.35px;
    width:20.5px;

}




.infoposter_desk_bas{
    height:1927px;
    position:relative;
    top:-7vh;
    width:100vw;
    background-image: url("/img/poster/desktop/bas.svg");
    background-repeat: no-repeat;
    background-position: center;

    }

.title-astuces{
    margin-top:30vh;
    margin-bottom:30vh;
}



@media screen and (max-width:1000px) and (min-width:431px){

    .postercontainer{
        position:relative;
        height:100%;
        margin-top:5vh;


    }


    .infoposter_desk_haut{
        position:relative;
        top:30px;
        height:2061.1146px;
        background-image: url("/img/poster/mobile/haut_mobile.svg");

    }

    .bouton_bonus {
        position:relative;
        top:-7px;
        transform: translateX(0%);
        background-color:#13345c;
        color: #fff;
        width: 215px;
        height:84.86px;
        text-align:center;
        border-radius:15px;
        z-index:2;

        font-family: 'Open Sans', Helvetica, serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 22px;
        letter-spacing: 0px;

    }


    .bouton_bonus_text {
        margin:0;
        font-family: 'Open Sans', Helvetica, serif;
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
        letter-spacing: 0px;
        text-align: center;

    }

    .infoposter_desk_bas{
      /*  height:288.9vh;*/
        height:1525.6087px;
        position:relative;
        top:-40px;

        background-image: url("/img/poster/mobile/bas_mobile.svg");

    }

}

@media screen and (max-width:430px) and (min-width:401px){

    .postercontainer{
        position:relative;
        height:100%;
        margin-top:0vh;


    }


    .infoposter_desk_haut{
        position:relative;
        top:30px;
        height:2061.1146px;
        background-image: url("/img/poster/mobile/haut_mobile.svg");

    }

    .bouton_bonus {
        position:relative;
        top:-7px;
        transform: translateX(0%);
        background-color:#13345c;
        color: #fff;
        width: 215px;
        height:84.86px;
        text-align:center;
        border-radius:15px;
        z-index:2;

        font-family: 'Open Sans', helvetica, serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 22px;
        letter-spacing: 0px;

    }

    .bouton_bonus_text {
        margin:0;
        font-family: 'Open Sans', Helvetica, serif;
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
        letter-spacing: 0px;
        text-align: center;

    }

    .infoposter_desk_bas{
        /*  height:288.9vh;*/
        height:1525.6087px;
        position:relative;
        top:-40px;

        background-image: url("/img/poster/mobile/bas_mobile.svg");

    }

}

@media screen and (max-width:400px){

    .postercontainer{
        position:relative;
        height:100%;
        margin-top:5vh;

    }

    .infoposter_desk_haut{
        position:relative;
        top:30px;
        height:2061.1146px;
        background-image: url("/img/poster/mobile/haut_mobile.svg");

    }

    .bouton_bonus {
        position:relative;
        top:-7px;
        transform: translateX(0%);
        background-color:#13345c;
        color: #fff;
        width: 215px;
        height:84.86px;
        text-align:center;
        border-radius:15px;
        z-index:2;

        font-family: 'Open Sans', Helvetica, serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 22px;
        letter-spacing: 0px;

    }

    .bouton_bonus_text {
        margin:0;
        font-family: 'Open Sans', Helvetica, serif;
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
        letter-spacing: 0px;
        text-align: center;

    }

    .infoposter_desk_bas{
        height:1525.6087px;
        position:relative;
        top:-40px;

        background-image: url("/img/poster/mobile/bas_mobile.svg");

    }

}



</style>